import { gql, useQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { CORE_PERMIT_REGISTER_FIELDS } from "../fragments/PermitRegister";
import {
  GetPermitToDigFilterOptions,
  GetPermitToDigFilterOptionsVariables,
} from "./__generated__/GetPermitToDigFilterOptions";

export const GET_PERMIT_TO_DIG_FILTER_OPTIONS = gql`
  ${CORE_PERMIT_REGISTER_FIELDS}
  query GetPermitToDigFilterOptions($permitRegisterId: String!) {
    permitRegister(id: $permitRegisterId) {
      ...CorePermitRegisterFields
      permitCreators {
        id
        user {
          id
          displayName
        }
      }
      assignedOrgUsers {
        id
        user {
          id
          displayName
        }
      }
    }
  }
`;

export function useGetPermitToDigFilterOptions(permitRegisterId: string | undefined) {
  const { loading, error, data } = useQuery<GetPermitToDigFilterOptions, GetPermitToDigFilterOptionsVariables>(
    GET_PERMIT_TO_DIG_FILTER_OPTIONS,
    {
      variables: { permitRegisterId: permitRegisterId! },
      skip: !permitRegisterId,
      fetchPolicy: "cache-and-network",
      errorPolicy: "all",
    },
  );

  return {
    data,
    status: { loading, errors: getErrors(error), successful: !error && data ? true : false } as AsyncQueryStatus,
  };
}